/**
 * Dynamic URL and Asset resolution for HomeBox
 * Supports Same-Origin proxy across all ports (80, 3000, 443, IP, domains).
 */

export const getHomeboxServiceUrl = () => {
  return `${window.location.origin}/homebox`;
};

export const getAuthServiceUrl = () => {
  return `${window.location.origin}/auth`;
};

/**
 * Returns full URL for an image asset.
 */
export const getFullImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
    return path;
  }
  const baseUrl = getHomeboxServiceUrl();
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

/**
 * Returns URL for thumbnail image (300px compressed) for fast mobile/desktop preview.
 */
export const getThumbnailUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('data:')) return path;
  if (path.includes('thumb_')) return getFullImageUrl(path);
  
  const lastSlash = path.lastIndexOf('/');
  if (lastSlash !== -1) {
    const thumbPath = `${path.substring(0, lastSlash + 1)}thumb_${path.substring(lastSlash + 1)}`;
    return getFullImageUrl(thumbPath);
  }
  return getFullImageUrl(path);
};
